<template>
  <div class="provider-branded-home">
    <div id="stickyBlockStartPoint" />
    <div>
      <div class="branded-cover-image-container">
        <template v-if="!loaded">
          <SkeletonUI type="img" class="cover-image" />
        </template>
        <template v-else>
          <img
            v-img="{ type:'xl', class: 'cover-image' }"
            class="w-100 branded-cover-image"
            :src="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hero_section && providerInfo[0].theme_data.landing.hero_section.cover_photo_url ? providerInfo[0].theme_data.landing.hero_section.cover_photo_url : loaded ? require('@/assets/img/provider-default/default-cover.jpg') : ''"
          >
        </template>
      </div>
      <div class="mb-5 mb-lg-7" />
    </div>
    <div class="container">
      <div class="row">
        <div v-for="(card, index) in home_cards" :key="index" class="col-md-4 mb-3 mb-md-0 mb-md-n11">
          <!-- Intro Card -->
          <div class="card h-100 transition-3d-hover">
            <div class="card-body p-lg-4">
              <div class="media align-items-center mb-2">
                <div class="media-body">
                  <h3 class="card-title mb-0">{{ $t(card.title) }}</h3>
                </div>
              </div>
              <p>{{ $t(card.description, { provider: card.provider_display_name ? providerInfo[0].display_name : undefined }) }}</p>
            </div>
            <div class="card-footer font-weight-bold py-3 px-lg-5">
              <router-link
                class="theme-link"
                :to="{ name: 'provider-info-branded', params: { provider_name: $route.params.provider_name, tab_name: card.link }, hash: card.hash }"
              >
                {{ $t(card.link_text) }}<i class="fas fa-angle-right fa-sm ml-1" />
              </router-link>
            </div>
          </div>
          <!-- End Intro Card -->
        </div>
      </div>
    </div>
    <div class="space-top-1 space-top-sm-3" />
    <div v-if="providerInfo[0] && providerInfo[0].theme_data && providerInfo[0].theme_data.landing && providerInfo[0].theme_data.landing.hiw_section && providerInfo[0].theme_data.landing.hiw_section.items && providerInfo[0].theme_data.landing.hiw_section.items.length > 0">
      <div v-for="(item, index) in providerInfo[0].theme_data.landing.hiw_section.items" :key="index">
        <div v-if="item.title && item.description && item.image_url" class="container space-1">
          <div class="row align-items-lg-center mb-5">
            <div class="col-lg-7 mb-7 mb-lg-0" :class="index % 2 === 1 ? 'order-lg-1' : 'order-lg-0'">
              <div>
                <h3 class="mb-3">{{ item.title }}</h3>
                <p class="text-justify mb-0">{{ item.description }}</p>
              </div>
            </div>
            <div class="col-lg-5" :class="index % 2 === 1 ? 'order-lg-0' : 'order-lg-1'">
              <div class="w-80 mx-auto mx-sm-auto mx-md-auto" :class="index % 2 === 1 ? 'mr-lg-auto ml-lg-0' : 'ml-lg-auto mr-lg-0'">
                <img v-if="item.image_url" v-img="{ type:'large', class: 'default-ratio' }" class="img-fluid" :src="item.image_url">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ========== End Trending APIs ========== -->
    <div v-if="latestApis.length > 0" class="container mt-5">
      <!-- Title -->
      <div class="row align-items-md-center mb-2">
        <div class="col-md-6 mb-2 mb-md-0">
          <h3>{{ $t('M05A-1-09') }}</h3>
        </div>
        <div class="col-md-6 text-md-right">
          <router-link class="provider-link" :to="{ name: 'provider-info-branded', params: { provider_name: $route.params.provider_name, tab_name: 'api' } }">
            <b>{{ $t('M05A-1-10a') }} <i class="fa fa-angle-right fa-sm ml-1" /></b>
          </router-link>
        </div>
      </div>
      <ApiCarousel
        :key="`latest-apis-${Date.now()}`"
        class="api-carousel-featured"
        :items="latestApis"
        :apiCardClickHandler="goToApiInfo"
        :isBranded="true"
        :fromProvider="true"
        carouselId="api-carousel-latest"
        :loading="loading"
      />
    </div>

    <div class="space-1" />
    <div id="stickyBlockEndPoint" />
    <!-- ========== Go to Top ========== -->
    <a
      class="js-go-to go-to position-fixed invisible"
      href="#stickyBlockStartPoint"
      data-hs-go-to-options="{
          &quot;targetSelector&quot; : &quot;#logoAndNav&quot;,
          &quot;offsetTop&quot;: 200,
          &quot;position&quot;: {
            &quot;init&quot;: {
              &quot;right&quot;: 30
            },
            &quot;show&quot;: {
              &quot;bottom&quot;: 30
            },
            &quot;hide&quot;: {
              &quot;bottom&quot;: -30
            }
          }
        }"
    >
      <i class="fas fa-angle-up" />
    </a>
    <!-- ========== End Go to Top ========== -->
  </div>
</template>

<script>
const $ = require('jquery')
import ApiCarousel from '@/components/api-carousel'
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
import providerInfoMixin from '@/mixins/provider-info'
import QuickLinks from './data/quick-links.json'
import { mapGetters } from 'vuex'

export default {
  name: 'ProviderInfoBrandedHomeBasic',
  components: {
    ApiCarousel
  },
  mixins: [providerInfoMixin],
  props: {
    latestApis: {
      type: Array,
      default: () => []
    },
    themeColor: {
      type: String,
      default: '#57ABF0'
    }
  },
  data() {
    return {
      home_cards: QuickLinks,
      loaded: false
    }
  },
  computed: {
    ...mapGetters(['userProfile', 'loading'])
  },
  watch: {
    async userProfile() {
      await this.initialise()
    },
    latestApis: {
      deep: true,
      handler() {}
    }
  },
  async created() {
    await this.initialise()
  },
  mounted() {
    new HSGoTo($('.js-go-to')).init()
  },
  methods: {
    async initialise() {
      this.$store.dispatch('app/setLoading', true)
      this.loaded = false
      var routeParams = this.$route.params && this.$route.params.provider_name.split('-')
      this.provider_short_id = routeParams[routeParams.length - 1]
      this.loaded = true
      this.$store.dispatch('app/setLoading', false)
    },
    goToApiInfo(item) {
      try {
        this.$router.push({
          name: 'api-info-branded',
          params: {
            provider_name: (item.display_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.provider_short_id}`)).replace(/\-+/g, '-'),
            api_name: (item.api_name.toLowerCase().replace(/[^A-Za-z0-9]/g, '-').concat(`-${item.api_short_id}`)).replace(/\-+/g, '-'),
            tab_name: 'readme'
          }
        })
      } catch (err) {
        console.log('err in goToApiInfo', err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~slick-carousel/slick/slick.css';
@import '~slick-carousel/slick/slick-theme.css';
.whitespace {
  white-space: pre-wrap;
}
.branded-cover-image-container {
  background:  linear-gradient(#f7f7f7, #ffffff);
  // min-height: 250px;
  max-width: 1680px;
  margin: auto;
  display: block;
}
.branded-cover-image {
  background-size: cover;
}
</style>
<style lang="scss">
.api-carousel-featured .slick-track {
  margin-left: 0;
}
.invisible {
  visibility: hidden;
}
</style>
